export default "__VITE_ASSET__BSXOMdeu__"